export enum OperatingSystem {
  WINDOWS = 'windows',
  MAC_OS = 'mac-os',
  IOS = 'ios',
  ANDROID = 'android',
  LINUX = 'linux',
  UNKNOWN = 'unknown'
}
